import React from 'react';

const Services = () => {
  return (
    <section className="package" id="package">
      <div className="container">

        <h2 className="h2 section-title">Checkout Our Services</h2>

        <p className="section-text">
        Welcome to our clinic, where your well-being is our priority. 
        Our dedicated team of healthcare professionals is committed to providing comprehensive and compassionate medical services. 
        From routine check-ups to specialized treatments, we offer a range of services designed to meet your healthcare needs. 
        </p>

        <ul className="package-list">

          <li>
            <div className="package-card">

              <figure className="card-banner">
                <img src="/grooming.jpg" alt="Let your animals experience the needed care." loading="lazy" />
              </figure>

              <div className="card-content">

                <h3 className="h3 card-title">Pamper Your Paws With Expert Pet Grooming Services</h3>

                <p className="card-text">
                Our skilled and caring groomers are dedicated to providing a stress-free and enjoyable grooming experience for your pets. 
                From stylish haircuts to soothing baths and meticulous nail trims, we tailor our services to meet the unique needs of each pet. 
                Your four-legged friends will leave not only looking their best but also feeling refreshed and revitalized. 
                </p>

              </div>

              <div className="card-price">


                <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  Book now
                </a>

              </div>

            </div>
          </li>
          <li>
            <div className="package-card">

              <figure className="card-banner">
                <img src="/treating.jpg" alt="Let your animals experience the needed care" loading="lazy" />
              </figure>

              <div className="card-content">

                <h3 className="h3 card-title">Spaying and Neutering Services</h3>

                <p className="card-text">
                Prioritize the long-term health and happiness of your pets with our dedicated spaying and neutering services.
                Beyond preventing unwanted litters, spaying and neutering offer numerous health benefits, 
                from reducing the risk of certain diseases to promoting behavioral balance. 
                Trust us to perform these essential procedures with the utmost care and expertise, ensuring the comfort and welfare of your pets. 
                Join us in promoting responsible pet ownership and securing a healthier, 
                happier future for your beloved companions through our spaying and neutering services. 
                </p>

              </div>

              <div className="card-price">

                <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  Book now
                </a>

              </div>

            </div>
          </li>
          <li>
            <div className="package-card">

              <figure className="card-banner">
                <img src="/Vaccinations.jpeg" alt="Let your animals experience the needed care" loading="lazy" />
              </figure>

              <div className="card-content">

                <h3 className="h3 card-title">Pet Vaccinations</h3>

                <p className="card-text">
                Vaccinations are a vital component of your pet's health care, providing essential protection against a range of infectious diseases. 
                At our clinic, we follow the latest guidelines to ensure that your pets receive the appropriate vaccines at the right times. 
                Vaccinations not only help prevent serious illnesses such as rabies, distemper, 
                and parvovirus but also contribute to the overall well-being of our community by controlling the spread of these diseases.  
                </p>

              </div>

              <div className="card-price">

                <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  Book now
                </a>

              </div>

            </div>
          </li>
          <li>
            <div className="package-card">

              <figure className="card-banner">
                <img src="/Surgeries.jpg" alt="Let your animals experience the needed care" loading="lazy" />
              </figure>

              <div className="card-content">

                <h3 className="h3 card-title">Surgeries</h3>

                <p className="card-text">
                From elective procedures like spaying and neutering to more complex surgeries such as tumor removals and orthopedic repairs, 
                we ensure that each operation is performed with the utmost precision and care. We utilize advanced surgical techniques and equipment, 
                including minimally invasive options when appropriate, to promote quicker recovery times and less postoperative discomfort. 
                Before any surgery, we conduct detailed assessments to determine the best approach, 
                ensuring that each procedure is tailored to the individual needs of your pet. With a focus on safety and efficacy, 
                we are committed to delivering high-quality surgical care that supports the long-term health of your beloved companions. 
                </p>

              </div>

              <div className="card-price">

                <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  Book now
                </a>

              </div>

            </div>
          </li>
          <li>
            <div className="package-card">

              <figure className="card-banner">
                <img src="/Transfer.jpg" alt="Let your animals experience the needed care" loading="lazy" />
              </figure>

              <div className="card-content">

                <h3 className="h3 card-title">Local & Inernational Pet Transfer</h3>

                <p className="card-text">
                Our clinic offers specialized pet transfer services to ensure a smooth and stress-free journey for your furry companions. 
                We understand the unique requirements and regulations associated with pet travel, 
                from health certificates and vaccinations to crate requirements and airline regulations. 
                Our dedicated team is here to guide you through every step, providing personalized assistance to coordinate logistics, 
                including transportation and documentation. Whether it’s a short trip across town or a long-distance journey overseas, 
                you can trust us to prioritize the comfort and safety of your pets, making their transition as seamless as possible. 
                </p>

              </div>

              <div className="card-price">

                <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  Book now
                </a>

              </div>

            </div>
          </li>
          <li>
            <div className="package-card">

              <figure className="card-banner">
                <img src="/Housecall.jpg.jpg" alt="Let your animals experience the needed care" loading="lazy" />
              </figure>

              <div className="card-content">

                <h3 className="h3 card-title">Housecall Services</h3>

                <p className="card-text">
                We understand that sometimes, visiting the clinic can be challenging for both pets and their owners. 
                That’s why we offer convenient housecall services, bringing expert veterinary care directly to your home. 
                Our mobile unit is equipped to handle a variety of services, including routine check-ups, vaccinations, and even minor procedures. 
                This personalized approach helps reduce the stress and anxiety that many pets experience during traditional visits. 
                Additionally, housecalls allow us to assess your pet’s environment, which can provide valuable insights into their health and behavior. 
                Our goal is to make veterinary care accessible and comfortable, 
                ensuring your beloved companions receive the attention they deserve in the comfort of their own home. 
                </p>

              </div>

              <div className="card-price">

                <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  Book now
                </a>

              </div>

            </div>
          </li>




          {/* Repeat the above structure for other package items */}

        </ul>

        <a href="https://api.whatsapp.com/send?phone=254707752571" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                  <button className="btn btn-primary">Inquire More</button>Book now
        </a>

      </div>
    </section>
  );
};

export default Services;
